import React from 'react';
import {confirmAlert} from 'react-confirm-alert';
import CustomUi from './custom-ui';

import './styles.css';

export const confirmAlertMui = ({
  open,
  title,
  onConfirm,
  message,
  loading,
  closeOnClickOutside = true,
}) => {
  confirmAlert({
    closeOnClickOutside: closeOnClickOutside,
    customUI: ({onClose}) => {
      return (
        <CustomUi
          onClose={onClose}
          open={open}
          title={title}
          onConfirm={onConfirm}
          message={message}
          loading={loading}
        />
      );
    },
  });
};
